import axios from "axios";
import { getLocalStorageMenuItem, setLocalStorageMenuItem } from "./storage";

export const FCM_TOKEN = "emrDNE9HT6CPp4zLHNud2D:APA91bG38qZDtmago4BR75an7y90JWZmcFLxZCzg_Jlk9ryO5pAbaMLzC2AUyLcNwYdlQnnaOeWIPBG0whyUnUUdMnYnM5cHa_OHgdz_gcchW8xQZP8bjkg";

export const getAndSaveTimeZone = async () => {
  try {
    const timeZone = getLocalStorageMenuItem("timezone");
    const countryCode = getLocalStorageMenuItem("countryCode");
    if (!timeZone || !countryCode) {
      const promise = await axios.get(`${process.env.REACT_APP_API}/timezone`);
      if (promise.status === 200) {
        const timezoneData = promise?.data?.data?.timezone || "";
        setLocalStorageMenuItem("countryCode", JSON.stringify(promise?.data?.data?.countryCode));
        setLocalStorageMenuItem("timezone", JSON.stringify(timezoneData));
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const sendNotificationFirebaseRes = async (detailsData, title, body, application_type) => {
  try {
    const params = new URLSearchParams(window.location.search);
    const response = await axios.post(
      `${process.env.REACT_APP_API}/send-firebase-notification`,
      {
        venue_id: detailsData?.venue_id,
        table_code: params.get("t") || "",
        title: title || "",
        body: body || "",
        application: application_type || "",
        gust_token: getLocalStorageMenuItem("gustToken"),
        data: {
          venue_id: detailsData?.venue_id,
          table: params.get("t") || "",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error sending notification:", error);
  }
};

export const fetchWalletBalance = async () => {
  try {
    const token = getLocalStorageMenuItem("mobileLoginToken");
    if (!token) return 0;

    const response = await axios.get(
      `${process.env.REACT_APP_API}/customer/wallet-balance`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const balance = parseFloat(response.data.data || 0);
    setLocalStorageMenuItem("customer_balance", balance.toString());
    return balance;
  } catch (error) {
    console.error("Error fetching wallet balance:", error);
    return 0;
  }
};

export const fetchLoyaltyPoints = async (venueId) => {
  try {
    const token = getLocalStorageMenuItem("mobileLoginToken");
    if (!token || !venueId) return { balance: 0, total_earned: 0, total_redeemed: 0 };

    const response = await axios.get(
      `${process.env.REACT_APP_API}/customer/loyalty-points?venue_id=${venueId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const pointsData = response.data.data;

    setLocalStorageMenuItem("loyalty_points_balance", pointsData.balance.toString());
    setLocalStorageMenuItem("loyalty_points_earned", pointsData.total_earned.toString());
    setLocalStorageMenuItem("loyalty_points_redeemed", pointsData.total_redeemed.toString());

    return {
      balance: parseFloat(pointsData.balance || 0),
      total_earned: parseFloat(pointsData.total_earned || 0),
      total_redeemed: parseFloat(pointsData.total_redeemed || 0),
      program: pointsData.program || null
    };
  } catch (error) {
    console.error("Error fetching loyalty points:", error);
    return { balance: 0, total_earned: 0, total_redeemed: 0, program: null };
  }
};
